import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { BuergscheinCreateSuper } from './bgsch-create.super';
import { BuergschaftsAntragTypes } from '../../../../model.module/bgsch-antrag-type.model';
import { FileUploadService } from '../../../../services.module/upload.service';
import { CreateBuergscheinModel } from '../../../../model.module/create-buergschein.model';
import { ConfigurationApiService } from '../../../../../generated/api/configuration/configuration.service';

@Component({
    selector: 'bgsch-create-abschl-3',
    templateUrl: './bgsch-create-abschl-3.component.html',
    styleUrls: ['./bgsch-create.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuergschaftCreateComponentAbschl3 extends BuergscheinCreateSuper {

    @Input()
    model: CreateBuergscheinModel = new CreateBuergscheinModel();

    urlBuergscheinAntragBedingungenPdf = '';

    constructor(
        private readonly configurationApiService: ConfigurationApiService,
        private readonly fileUploadService: FileUploadService,
    ) {
        super();

        this.configurationApiService.getConfiguration().subscribe(configuration => {
            this.urlBuergscheinAntragBedingungenPdf = configuration.urlBuergscheinAntragBedingungenPdf;
        });
    }

    getFormularText(): string {
        if (!this.model.gewuenschtesFormular.value) {
            return '';
        }

        const formularTyp = BuergschaftsAntragTypes.findByFormularKuerzel(this.model.gewuenschtesFormular.value);

        if (formularTyp) {
            return formularTyp.right;
        }

        return '';
    }

    getFileName(index: number): string {
        return this.fileUploadService.getFileNameOrNull(index);
    }

    canShowBuergschaftszusaetze(): boolean {
        return this.model.checkboxHinterlegung.value
            || this.model.checkboxBGB768.value
            || this.model.checkboxSGBVII150Abs3.value
            || this.model.checkboxSGBIV28eAbs3a.value
            || this.model.checkboxSicherheitseinbehalt.value
            || this.model.checkboxAentG14.value;
    }

    getGewaehrleistungsfrist(): string {
        if (this.model.gewaehrleistungsfrist.value === '5') {
            return '5 Jahre';
        }

        if (this.model.gewaehrleistungsfrist.value === '4') {
            return '4 Jahre';
        }

        let result = '';

        if (this.canShowItem(this.model.gewaehrleistungsfristJahre) && this.model.gewaehrleistungsfristJahre.value !== '0') {
            if (this.model.gewaehrleistungsfristJahre.value === '1') {
                result += '1 Jahr';
            } else {
                result += this.model.gewaehrleistungsfristJahre.value + ' Jahre'
            }
        }

        if (this.canShowItem(this.model.gewaehrleistungsfristMonate) && this.model.gewaehrleistungsfristMonate.value !== '0') {
            if (result) {
                result += ' + ';
            }

            if (this.model.gewaehrleistungsfristMonate.value === '1') {
                result += '1 Monat';
            } else {
                result += this.model.gewaehrleistungsfristMonate.value + ' Monate'
            }
        }

        return result;
    }

}
